import { EXDEV } from 'constants';

export { default as NotiflyLogo } from '../../src/containers/App/Assets/img/notifly.png';
export { default as FbIcon } from '../../src/containers/App/Assets/img/iconfb.png';
export { default as GglIcon } from '../../src/containers/App/Assets/img/icongg.png';
export { default as ShopyIcon } from '../../src/containers/App/Assets/img/iconshopy.png';
export { default as backIcon } from '../../src/containers/App/Assets/img/iconbkarrow.png';
export { default as ShopifyLogoLine } from '../../src/containers/App/Assets/img/shopifylogo-line.png';
export { default as LoginNotiOne } from '../../src/containers/App/Assets/img/work-noti-1.png';
export { default as LoginNotiOneStyle } from '../../src/containers/App/Assets/img/work-noti-1-1.png';
export { default as LoginNotiTwo } from '../../src/containers/App/Assets/img/work-noti-2.png';
export { default as LoginNotiTwoStyle } from '../../src/containers/App/Assets/img/work-noti-2-1.png';
export { default as LoginNotiThird } from '../../src/containers/App/Assets/img/work-noti-3.png';
export { default as LoginNotiThirdStyle } from '../../src/containers/App/Assets/img/work-noti-3-1.png';
export { default as LoginNotiFour } from '../../src/containers/App/Assets/img/work-noti-4.png';
export { default as LoginNotiFourStyle } from '../../src/containers/App/Assets/img/work-noti-4-1.png';
export { default as loginUserBg } from '../../src/containers/App/Assets/img/logn-bg.png';
export { default as loginrightBg } from '../../src/containers/App/Assets/img/login-img.png';
export { default as loginrightBg01 } from '../../src/containers/App/Assets/img/login-img-1.png';
export { default as logown } from '../../src/containers/App/Assets/img/wiser-notifly.png';
export { default as widgetLogo } from '../../src/containers/App/Assets/img/widget-logo.png';
export { default as loginrightBg02 } from '../../src/containers/App/Assets/img/login-right-02.png';

//SIDEBAR ICON
export { default as IconNotifly } from '../../src/containers/App/Assets/img/iconnotifly.png';
export { default as IconDashboard } from '../../src/containers/App/Assets/img/icondashboard.png';
export { default as IconNotification } from '../../src/containers/App/Assets/img/iconnotification.png';
export { default as IconVisitor } from '../../src/containers/App/Assets/img/iconvisitor.png';
export { default as IconGoal } from '../../src/containers/App/Assets/img/icongoal.png';
export { default as IconAnalytic } from '../../src/containers/App/Assets/img/icon_analytic.png';
export { default as IconSetting } from '../../src/containers/App/Assets/img/iconsetting.png';
export { default as IconIntegration } from '../../src/containers/App/Assets/img/iconintegration.png';
export { default as IconData } from '../../src/containers/App/Assets/img/icondata.png';
export { default as IconNotiSidebar } from '../../src/containers/App/Assets/img/iconnotfication.png';
export { default as IconCommission } from '../../src/containers/App/Assets/img/commission.png';
export { default as IconCommission1 } from '../../src/containers/App/Assets/img/commission (1).png';

//HEADERBAR ICON
export { default as IconNavLink } from '../../src/containers/App/Assets/img/iconmenu.png';
export { default as UserImg } from '../../src/containers/App/Assets/img/userimg.png';
export { default as IconHelp } from '../../src/containers/App/Assets/img/iconhelp.png';
export { default as IconNoti } from '../../src/containers/App/Assets/img/iconbell.png';
export { default as IconIndropSetting } from '../../src/containers/App/Assets/img/iconsettingddd.png';
export { default as IconIndropPayment } from '../../src/containers/App/Assets/img/iconpaymentdd.png';
export { default as IconIndropInvoice } from '../../src/containers/App/Assets/img/iconinvoicedd.png';
export { default as IconIndropSignout } from '../../src/containers/App/Assets/img/iconsignoutdd.png';
export { default as IconSignout } from '../../src/containers/App/Assets/img/iconsignout.png';
export { default as IconInfoWeb } from '../../src/containers/App/Assets/img/iconinformation.png';


//ADD NOTIFICATION
export { default as AddNotisideBg } from '../../src/containers/App/Assets/img/addnotirightside.png';
export { default as IconDelete } from '../../src/containers/App/Assets/img/icondelete.png';
export { default as AddNotiStart } from '../../src/containers/App/Assets/img/add-noti-start.png';
//NOTIFICATION TYPE ICON
export { default as IconLVEditor } from '../../src/containers/App/Assets/img/iconlveditor.png';
export { default as IconLVStrem } from '../../src/containers/App/Assets/img/iconlvstrem.png';
export { default as IconLVProduct } from '../../src/containers/App/Assets/img/iconlvproductwise.png';
export { default as IconBulkPurchased } from '../../src/containers/App/Assets/img/iconbulkpurchased.png';
export { default as IconBulkVisitor } from '../../src/containers/App/Assets/img/iconbulkvisitor.png';
export { default as IconBulSign } from '../../src/containers/App/Assets/img/iconbulsign.png';

//NOTIFICATION DESIGN 
export { default as IconUserNoti } from '../../src/containers/App/Assets/img/iconusernoti.png';
export { default as IconNotiText } from '../../src/containers/App/Assets/img/iconnotitext.png';
export { default as IconNotiColor } from '../../src/containers/App/Assets/img/iconnoticolor.png';
export { default as IconNotiSetting } from '../../src/containers/App/Assets/img/iconnotisetting.png';
export { default as IconSelectArrow } from '../../src/containers/App/Assets/img/iconselectarrow.png';
export { default as IconRedirectUrl } from '../../src/containers/App/Assets/img/iconredirecturl.png';
export { default as IconEditImg } from '../../src/containers/App/Assets/img/iconeditimg.png';
export { default as IconNotiEdit } from '../../src/containers/App/Assets/img/iconnotiedit.png';
export { default as IconInformation } from '../../src/containers/App/Assets/img/info.png';
// export { default as IconGoogle } from '../../src/containers/App/Assets/img/icongoogle.png';
export { default as IconAwDown } from '../../src/containers/App/Assets/img/iconardown.png';
export { default as IconClose } from '../../src/containers/App/Assets/img/iconclose.png';
export { default as IconSliderArw } from '../../src/containers/App/Assets/img/iconsliderarw.png';
export { default as Iconwaning } from '../../src/containers/App/Assets/img/iconplanwarn.png';
export { default as Imgwebsite } from '../../src/containers/App/Assets/img/website.png';
export { default as Imgsafarihead } from '../../src/containers/App/Assets/img/safari-head.png';
export { default as Imgsafaribrowser } from '../../src/containers/App/Assets/img/safari-head-1.svg';
export { default as ImgsafariBwidget } from '../../src/containers/App/Assets/img/safari-widget-1.svg';

//PIXEL
export { default as IconBtnMypixel } from '../../src/containers/App/Assets/img/iconbtnmypixel.png';
export { default as IconBtnCopy } from '../../src/containers/App/Assets/img/iconbtncopy.png';
export { default as IconGuideWordp } from '../../src/containers/App/Assets/img/iconguidewordp.png';
export { default as IconGuideHtml } from '../../src/containers/App/Assets/img/iconguidehtml.png';
export { default as IconGuideTag } from '../../src/containers/App/Assets/img/iconguidetag.png';
export { default as IconGuideMagento } from '../../src/containers/App/Assets/img/iconguidemagento.png';
export { default as IconGuidePlus } from '../../src/containers/App/Assets/img/iconplus.png';

//PAYMENT
export { default as IconPrint } from '../../src/containers/App/Assets/img/iconprint.png';

//INTEGRATION
export { default as IconEllipsis } from '../../src/containers/App/Assets/img/iconellipsis.png';
export { default as IconIntiInfo } from '../../src/containers/App/Assets/img/information.svg';

//PROFILE PAGE
export { default as UserProfile } from '../../src/containers/App/Assets/img/user.png';
export { default as IconProfileEdit } from '../../src/containers/App/Assets/img/icon-profile-edit.png';
export { default as IconProfileEditPen } from '../../src/containers/App/Assets/img/iconprofileedit.png';

//VISITOR
export { default as IconLocation } from '../../src/containers/App/Assets/img/iconlocation.png';

//DASHBOARD
export { default as Chart } from '../../src/containers/App/Assets/img/chart.png';
export { default as IconChartDown } from '../../src/containers/App/Assets/img/iconchartdown.png';
export { default as IconChartUp } from '../../src/containers/App/Assets/img/iconchartup.png';
export { default as IconCloseWht } from '../../src/containers/App/Assets/img/iconclose-white.png';

//ANALYTIC
export { default as AnalyticChartLeft } from '../../src/containers/App/Assets/img/analyticchart-1.png';
export { default as AnalyticChartRight } from '../../src/containers/App/Assets/img/analyticchart-2.png';
export { default as Testanalytic } from '../../src/containers/App/Assets/img/testanalytic.svg';


//LOGO
export { default as IconLogo } from '../../src/containers/App/Assets/img/logo-nw.png';
export { default as IconLogoText } from '../../src/containers/App/Assets/img/logo-text-nw.png';


//PLAN
export { default as PlanBenefitImg } from '../../src/containers/App/Assets/img/plan-2.png';


//NO DATA 
export { default as NoDataImg } from '../../src/containers/App/Assets/img/add-noti-start-1.png';
export { default as NoDataBox } from '../../src/containers/App/Assets/img/noData.png';

//NO DATA 
export { default as NotiDemo } from '../../src/containers/App/Assets/img/notification-1.png';
export { default as NotiDemo2 } from '../../src/containers/App/Assets/img/notification-2.png';
export { default as NotiDemo3 } from '../../src/containers/App/Assets/img/notification-3.png';

export { default as UploadCompany } from '../../src/containers/App/Assets/img/upload-company.png';



export { default as IconFb } from '../../src/containers/App/Assets/img/icon-facebook.svg';
export { default as IconTt } from '../../src/containers/App/Assets/img/icon-twitter.svg';
export { default as IconLd } from '../../src/containers/App/Assets/img/icon-linkedin.svg';
export { default as IconInsta } from '../../src/containers/App/Assets/img/icon-instagram.svg';
export { default as InstaRound } from '../../src/containers/App/Assets/img/InstaIcon.png';
export { default as Capterra } from '../../src/containers/App/Assets/img/capterra.png';
export { default as AddNotiArw } from '../../src/containers/App/Assets/img/add-noti-arrow.png';
export { default as AddNotisideArw } from '../../src/containers/App/Assets/img/addnotirightside-2.png';
export { default as Appsumo } from '../../src/containers/App/Assets/img/logo-appsumo.png';
export { default as WiserIcon } from '../../src/containers/App/Assets/img/logo-icon.png';


///NEW IMAGES [S]
export { default as Theme1 } from '../../src/containers/App/Assets/img/theme-1.png';
export { default as Theme2 } from '../../src/containers/App/Assets/img/theme-2.png';
export { default as Card1 } from '../../src/containers/App/Assets/img/card-2.png';
export { default as Card2 } from '../../src/containers/App/Assets/img/card-3.png';
export { default as AppIconInsta } from '../../src/containers/App/Assets/img/instagramfeed.svg';
export { default as AppIconGg } from '../../src/containers/App/Assets/img/google-icon.svg';
export { default as AppGraph } from '../../src/containers/App/Assets/img/graph.svg';
export { default as Icongg } from '../../src/containers/App/Assets/img/icon-gg.svg';

export { default as IconAvatar } from '../../src/containers/App/Assets/img/avatar.png';
//export { default as RytsideImg } from '../../src/containers/App/Assets/img/ryt-side.png';
export { default as EditWhite } from '../../src/containers/App/Assets/img/editwht.png';
export { default as Wordp } from '../../src/containers/App/Assets/img/wordp.png';
export { default as Magento } from '../../src/containers/App/Assets/img/magento.png';
export { default as Nopc } from '../../src/containers/App/Assets/img/nopc.png';
export { default as Presta } from '../../src/containers/App/Assets/img/presta.png';
export { default as Openc } from '../../src/containers/App/Assets/img/openc.png';
export { default as Star } from '../../src/containers/App/Assets/img/star.png';
export { default as Sidepnlmng } from '../../src/containers/App/Assets/img/sidepanalemanage.png';
export { default as InteConnect } from '../../src/containers/App/Assets/img/connect.png';
export { default as shopifyfull } from '../../src/containers/App/Assets/img/shopifyfull.svg';
export { default as bigcomfull } from '../../src/containers/App/Assets/img/bigcomfull.svg';

export { default as g2 } from '../../src/containers/App/Assets/img/g2.svg';
export { default as twit } from '../../src/containers/App/Assets/img/twit.svg';
export { default as insta } from '../../src/containers/App/Assets/img/insta.svg';
export { default as cap } from '../../src/containers/App/Assets/img/cap.svg';
export { default as fb } from '../../src/containers/App/Assets/img/fb.svg';
export { default as ggle } from '../../src/containers/App/Assets/img/ggle.svg';
export { default as lin } from '../../src/containers/App/Assets/img/in.svg';
export { default as wisernotiapp } from '../../src/containers/App/Assets/img/wiser-noti.png';
export { default as wisersocialwallapp } from '../../src/containers/App/Assets/img/wiser-socialwall.png';

// font style dropdown
export { default as Bold } from '../../src/containers/App/Assets/img/style B.png';
export { default as Italic } from '../../src/containers/App/Assets/img/style I.png';
export { default as Underline } from '../../src/containers/App/Assets/img/style U.png';
export { default as Normal } from '../../src/containers/App/Assets/img/style N.png';


// WEBPACK FOOTER //
// ./src/img/index.js